import LineChartIcon from "components/Icons/charts/LineChartIcon";
import MeasurementsTableIcon from "components/Icons/charts/MeasurementsTableIcon";
import ProfilingChartIcon from "components/Icons/charts/ProfilingChartIcon";
import SetComparisonChartIcon from "components/Icons/charts/SetComparisonChartIcon";
import OneRepMaxIcon from "components/Icons/OneRepMaxIcon";

export enum DataVisualizationType {
  LINE_CHART = "line",
  MEASUREMENTS_TABLE = "measurements",
  SET_COMPARISON_CHART = "set-comparison",
  PROFILING_CHART = "profiling",
  ONE_REP_MAX_CHART = "1rm",
}

export const dataVisualizationOptions = [
  {
    type: DataVisualizationType.LINE_CHART,
    titleKey: "chart_types.line_chart",
    icon: <LineChartIcon color="inherit" />,
    descriptionKey: "chart_types.line_chart_description",
  },
  {
    type: DataVisualizationType.MEASUREMENTS_TABLE,
    titleKey: "chart_types.measurements_table",
    icon: <MeasurementsTableIcon color="inherit" />,
    descriptionKey: "chart_types.measurements_table_description",
  },
  {
    type: DataVisualizationType.SET_COMPARISON_CHART,
    titleKey: "chart_types.set_comparison",
    icon: <SetComparisonChartIcon color="inherit" />,
    descriptionKey: "athlete_profile.set_comparison_vis_type_title",
  },
  {
    type: DataVisualizationType.PROFILING_CHART,
    titleKey: "chart_types.profiling_chart",
    icon: <ProfilingChartIcon color="inherit" />,
    descriptionKey: "global.profiling_label",
  },
  {
    type: DataVisualizationType.ONE_REP_MAX_CHART,
    titleKey: "chart_types.1rm_chart",
    icon: <OneRepMaxIcon />,
    descriptionKey: "athlete_profile.one_rep_max_vis_type_title",
  },
];
